import type { IMarket } from 'data/schema';

export const marketNames: Record<IMarket, string> = {
  ARE: 'United Arab Emirates',
  ARG: 'Argentina',
  AUS: 'Australia',
  AUT: 'Austria',
  BEL: 'Belgium',
  BHR: 'Bahrain',
  BOL: 'Bolivia',
  BIH: 'Bosnia and Herzegovina',
  BRA: 'Brazil',
  CAN: 'Canada',
  CHE: 'Switzerland',
  CHL: 'Chile',
  CHN: 'China',
  COL: 'Colombia',
  CRI: 'Costa Rica',
  CYP: 'Cyprus',
  CYM: 'Cayman Islands',
  CUW: 'Curaçao',
  DEU: 'Germany',
  DNK: 'Denmark',
  DOM: 'Dominican Republic',
  ECU: 'Ecuador',
  EGY: 'Egypt',
  ESP: 'Spain',
  EST: 'Estonia',
  FIN: 'Finland',
  FRA: 'France',
  GBR: 'United Kingdom',
  GLP: 'Guadeloupe',
  GRC: 'Greece',
  GTM: 'Guatemala',
  GUF: 'French Guiana',
  IRL: 'Ireland',
  ITA: 'Italy',
  IND: 'India',
  JAM: 'Jamaica',
  JOR: 'Jordan',
  JPN: 'Japan',
  KOR: 'South Korea',
  KWT: 'Kuwait',
  LBN: 'Lebanon',
  LCA: 'Saint Lucia',
  LUX: 'Luxembourg',
  LVA: 'Latvia',
  LTU: 'Lithuania',
  MEX: 'Mexico',
  MTQ: 'Martinique',
  NLD: 'Netherlands',
  NOR: 'Norway',
  NZL: 'New Zealand',
  OMN: 'Oman',
  PAN: 'Panama',
  PER: 'Peru',
  POL: 'Poland',
  PRY: 'Paraguay',
  QAT: 'Qatar',
  ROU: 'Romania',
  SAU: 'Saudi Arabia',
  SGP: 'Singapore',
  SLV: 'El Salvador',
  SRB: 'Serbia',
  SVK: 'Slovakia',
  SWE: 'Sweden',
  SXM: 'Sint Maarten',
  TTO: 'Trinidad and Tobago',
  TUR: 'Turkey',
  TWN: 'Taiwan',
  URY: 'Uruguay',
  USA: 'United States',
  ZAF: 'South Africa',
  DEV: 'Development',
  '*': 'All Markets',
};

export const marketFlags: Record<IMarket, string> = {
  ARE: '🇦🇪', // United Arab Emirates
  ARG: '🇦🇷', // Argentina
  AUS: '🇦🇺', // Australia
  AUT: '🇦🇹', // Austria
  BEL: '🇧🇪', // Belgium
  BHR: '🇧🇭', // Bahrain
  BOL: '🇧🇴', // Bolivia
  BIH: '🇧🇦', // Bosnia and Herzegovina
  BRA: '🇧🇷', // Brazil
  CAN: '🇨🇦', // Canada
  CHE: '🇨🇭', // Switzerland
  CHL: '🇨🇱', // Chile
  CHN: '🇨🇳', // China
  COL: '🇨🇴', // Colombia
  CRI: '🇨🇷', // Costa Rica
  CYP: '🇨🇾', // Cyprus
  CYM: '🇰🇾', // Cayman Islands
  CUW: '🇨🇼', // Curaçao
  DEU: '🇩🇪', // Germany
  DNK: '🇩🇰', // Denmark
  DOM: '🇩🇴', // Dominican Republic
  ECU: '🇪🇨', // Ecuador
  EGY: '🇪🇬', // Egypt
  ESP: '🇪🇸', // Spain
  EST: '🇪🇪', // Estonia
  FIN: '🇫🇮', // Finland
  FRA: '🇫🇷', // France
  GBR: '🇬🇧', // United Kingdom
  GLP: '🇬🇵', // Guadeloupe
  GRC: '🇬🇷', // Greece
  GTM: '🇬🇹', // Guatemala
  GUF: '🇬🇫', // French Guiana
  IRL: '🇮🇪', // Ireland
  ITA: '🇮🇹', // Italy
  IND: '🇮🇳', // India
  JAM: '🇯🇲', // Jamaica
  JOR: '🇯🇴', // Jordan
  JPN: '🇯🇵', // Japan
  KOR: '🇰🇷', // South Korea
  KWT: '🇰🇼', // Kuwait
  LBN: '🇱🇧', // Lebanon
  LCA: '🇱🇨', // Saint Lucia
  LUX: '🇱🇺', // Luxembourg
  LVA: '🇱🇻', // Latvia
  LTU: '🇱🇹', // Lithuania
  MEX: '🇲🇽', // Mexico
  MTQ: '🇲🇶', // Martinique
  NLD: '🇳🇱', // Netherlands
  NOR: '🇳🇴', // Norway
  NZL: '🇳🇿', // New Zealand
  OMN: '🇴🇲', // Oman
  PAN: '🇵🇦', // Panama
  PER: '🇵🇪', // Peru
  POL: '🇵🇱', // Poland
  PRY: '🇵🇾', // Paraguay
  QAT: '🇶🇦', // Qatar
  ROU: '🇷🇴', // Romania
  SAU: '🇸🇦', // Saudi Arabia
  SGP: '🇸🇬', // Singapore
  SLV: '🇸🇻', // El Salvador
  SRB: '🇷🇸', // Serbia
  SVK: '🇸🇰', // Slovakia
  SWE: '🇸🇪', // Sweden
  SXM: '🇸🇽', // Sint Maarten
  TTO: '🇹🇹', // Trinidad and Tobago
  TUR: '🇹🇷', // Turkey
  TWN: '🇹🇼', // Taiwan
  URY: '🇺🇾', // Uruguay
  USA: '🇺🇸', // United States
  ZAF: '🇿🇦', // South Africa
  DEV: '🏴', // Development (black flag)
  '*': '🌍', // All markets (world globe)
};

export function getMarketDisplayName(market: string): string {
  const name = marketNames[market as keyof typeof marketNames];
  const flag = marketFlags[market as keyof typeof marketFlags] ?? '';
  if (!name) return market;
  return `${flag} ${name} (${market})`;
}
